import { useQuery } from 'react-query';

import type { IActivity } from 'src/services/api/activities';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_ACTIVITIES_PATH } from 'src/services/api/activities/constants';

export type IGetActivitiesResponse = {
    activities: Array<IActivity>;
}

export const useActivities = (opts?: { enabled?: boolean }) => {
    return useQuery(
        [queryKeys.activities],
        async () => {
            const res = await apiClient(GET_ACTIVITIES_PATH).json<IGetActivitiesResponse>();
            return res.activities;
        },
        { enabled: opts?.enabled ?? true }
    );
};